/* eslint-disable no-alert */
import React, { Component } from "react"
import styled from "styled-components"
import { Label, StyledInput, ErrorMsg } from "./styled/styledInput"
import { StyledButton } from "./Button"
import sendIcon from "../images/icons/send-icon.svg"

const StyledLabel = styled(Label)`
  margin-top: 32px;
`

const StyledErrMsg = styled(ErrorMsg)`
  transform: translateY(26px);
  transition: transform 0.2s ease;
`

const Desc = styled.p`
  letter-spacing: 0.4px;
  color: #808080;
  @media (min-width: 1024px) {
    font-size: 20px;
    letter-spacing: 0.5px;
  }
  @media (min-width: 1200px) {
    &.services {
      border-top: 2px solid #f9d6c1;
      padding-top: 27px;
      margin-top: 17px;
    }
  }
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  padding-bottom: 30px;
  /* prettier-ignore */
  ${Desc}:nth-of-type(2) {
    margin-top: 32px;
    @media (min-width: 1024px){
      margin-top: 40px;
    }
  }
  ${StyledLabel}:first-of-type {
    margin-top: 56px;
    @media (min-width: 1024px) {
      margin-top: 32px;
    }
  }
  @media (min-width: 1200px) {
    flex-basis: 60%;
    margin-top: 0;
  }
  @media (min-width: 1600px) {
    flex-basis: 70%;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    box-shadow: 0 0 0 30px white inset !important;
  }
`

const CheckboxContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 4px;
  @media (min-width: 1024px) {
    margin-top: 10px;
  }
`
const BudgetContainer = styled(CheckboxContainer)`
  & input {
    flex-basis: calc(50% - 16px);
  }
  @media (min-width: 1024px) {
    & input {
      flex-basis: auto;
    }
  }
`
const Checkbox = styled.input`
  position: relative;
  background-color: transparent;
  border-radius: 8px;
  border: solid 1px #808080;
  margin: 4px 8px 4px 0;
  display: block;
  width:auto;
  appearance: none;
  height:auto;
  padding:7px 12px;
  transition: .2s;
  outline:0;
  &::before {
    content: "${props => props.value}";
    display:flex;
    align-items: center;
    justify-content: center;
    color: #151515;
    text-align: center;
    font-size: 16px;
    letter-spacing: 0.5px;
    height:100%;
  }
  &:checked{
      background-color: #c39779;
      border: solid 1px #c39779;
      outline:0;
      &::before{
        color: #fff;
    }
  }
  @media (min-width: 1024px) {
    margin: 4px 20px 4px 0;
    &::before{
      font-size: 20px;
    }
  }
`

const SendIcon = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: 0.2s ease;
`

const SubmitButton = styled(StyledButton)`
  font-family: "Made Medium", sans-serif;
  font-size: 24px;
  letter-spacing: 0.5px;
  margin-top: 16px;
  width: 100%;
  box-shadow: 0 2px 8px 0 rgba(71, 77, 196, 0.5);
  position: relative;
  & span {
    transition: 0.2s ease;
    display: inline-block;
  }
  &:hover {
    & span {
      transform: translateX(-12px);
    }
    & ${SendIcon} {
      transform: translate(24px, -50%);
      opacity: 1;
    }
  }
`
const InfoAboutUs = styled.button`
  color: #808080;
  letter-spacing: 0.3px;
  align-self: flex-start;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  & span {
    color: #151515;
    font-size: 16px;
    letter-spacing: 0.5px;
    margin-left: 8px;
  }
  @media (min-width: 1024px) {
    align-self: center;
    margin-top: 0;
  }
`

const InputContainer = styled.div`
  ${StyledLabel} {
    & input {
      margin: 32px 0 0;
    }
  }
  @media (min-width: 1024px) {
    display: flex;
    margin: 32px 0;
    ${StyledLabel}:first-child {
      margin-right: 30px;
    }
    ${StyledLabel} {
      & input {
        margin: 0;
      }
    }
  }
`
const ButtonContainer = styled.div`
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-top: 40px;
    ${SubmitButton} {
      width: 170px;
      padding: 11px 0;
      margin-top: 0;
    }
  }
`

const encode = data => {
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&")
}

class ContactForm extends Component {
  state = { name: "", email: "", description: "", services: [], budget: "" }

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleService = e => {
    const inputs = document.querySelectorAll(".checkbox-container input")
    const arrInputs = [...inputs]
    const { services } = this.state
    if (e.target.checked) {
      this.setState({
        services: [...services, e.target.value],
      })
      arrInputs.filter(item => item.value !== e.target.value)
      arrInputs.forEach(input => input.removeAttribute("required"))
    } else if (services.length === 1) {
      this.setState({ services: [] })
      arrInputs.forEach(input => input.setAttribute("required", true))
    } else {
      this.setState({
        services: services.filter(item => item !== e.target.value),
      })
    }
  }

  handleBudget = e => {
    const inputs = document.querySelectorAll(".budget-container input")
    const arrInputs = [...inputs]
    if (e.target.checked) {
      this.setState({
        budget: e.target.value,
      })
      e.target.setAttribute("required", true)
      arrInputs
        .filter(item => item.value !== e.target.value)
        .forEach(input => input.removeAttribute("required"))
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    // eslint-disable-next-line no-undef
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "Contact Form", ...this.state }),
    })
      .then(() => alert("Wysłano maila, dziękujemy!"))
      .catch(error => alert(error))
  }

  render() {
    const { name, email, description } = this.state
    return (
      <Form
        name="Contact Form"
        method="post"
        data-netlify="true"
        onSubmit={this.handleSubmit}
      >
        <input type="hidden" name="form-name" value="Contact Form" />
        <Desc className="services">Usługi</Desc>
        <CheckboxContainer className="checkbox-container">
          <Checkbox
            type="checkbox"
            name="aplikacja-internetowa"
            value="Aplikacja internetowa"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
          <Checkbox
            type="checkbox"
            name="strona-www"
            value="Strona www"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
          <Checkbox
            type="checkbox"
            name="sklep-internetowy"
            value="Sklep internetowy"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
          <Checkbox
            type="checkbox"
            name="badania-rynku"
            value="Badania rynku"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
          <Checkbox
            type="checkbox"
            name="design"
            value="UX/UI Design"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
          <Checkbox
            type="checkbox"
            name="logo"
            value="Logo"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
          <Checkbox
            type="checkbox"
            name="social-media"
            value="Social media"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
            id="socials"
          />
          <Checkbox
            type="checkbox"
            name="branding"
            value="Branding"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
          <Checkbox
            type="checkbox"
            name="materiały-drukowane"
            value="Materiały drukowane"
            onClick={this.handleService}
            required
            aria-label="Checkbox"
          />
        </CheckboxContainer>
        <Desc>Budżet w PLN(opcjonalnie)</Desc>
        <BudgetContainer className="budget-container">
          <Checkbox
            type="radio"
            name="budget"
            value="Poniżej 5K"
            onClick={this.handleBudget}
            aria-label="Checkbox"
          />
          <Checkbox
            type="radio"
            name="budget"
            value="5K - 10K"
            onClick={this.handleBudget}
            aria-label="Checkbox"
          />
          <Checkbox
            type="radio"
            name="budget"
            value="10K - 30K"
            onClick={this.handleBudget}
            aria-label="Checkbox"
          />
          <Checkbox
            type="radio"
            name="budget"
            value="Powyżej 30K"
            onClick={this.handleBudget}
            aria-label="Checkbox"
          />
        </BudgetContainer>
        <InputContainer className="input-container">
          <StyledLabel htmlFor="name">
            <StyledInput
              type="text"
              name="name"
              value={name}
              onChange={this.handleChange}
              required
              id="name"
            />
            <span className={["floating-label", name && "hasText"].join(" ")}>
              Imię
            </span>
            <StyledErrMsg>Podaj swoje imię</StyledErrMsg>
          </StyledLabel>
          <StyledLabel htmlFor="email">
            <StyledInput
              type="email"
              name="email"
              value={email}
              onChange={this.handleChange}
              required
              id="email"
            />
            <span className={["floating-label", email && "hasText"].join(" ")}>
              Email
            </span>
            <StyledErrMsg>Podaj swój email</StyledErrMsg>
          </StyledLabel>
        </InputContainer>
        <StyledLabel htmlFor="description">
          <StyledInput
            type="text"
            name="description"
            value={description}
            onChange={this.handleChange}
            id="description"
          />
          <span
            className={["floating-label", description && "hasText"].join(" ")}
          >
            Szczegóły projektu
          </span>
        </StyledLabel>
        <ButtonContainer>
          <SubmitButton type="submit">
            <span>Wyślij</span>{" "}
            <SendIcon
              src={sendIcon}
              alt="Wyślij wiadomość"
              title="Skontaktuj się z nami!"
            />
          </SubmitButton>
          <InfoAboutUs>
            Jak nas znalazłeś? <span>&gt;</span>
          </InfoAboutUs>
        </ButtonContainer>
      </Form>
    )
  }
}

export default ContactForm
